var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cached"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.25 6L11.25 9H13.5C13.5 11.4825 11.4825 13.5 9 13.5C8.2425 13.5 7.5225 13.3125 6.9 12.975L5.805 14.07C6.7275 14.655 7.8225 15 9 15C12.315 15 15 12.315 15 9H17.25L14.25 6ZM4.5 9C4.5 6.5175 6.5175 4.5 9 4.5C9.7575 4.5 10.4775 4.6875 11.1 5.025L12.195 3.93C11.2725 3.345 10.1775 3 9 3C5.685 3 3 5.685 3 9H0.75L3.75 12L6.75 9H4.5Z",
    fill: "#5B6670"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/Retry.cd49600c274b3e20b3e6d0c617be7298.svg";
export { ForwardRef as ReactComponent };